import { Dropdown } from "../utils/dropdown";

const header = document.querySelector(".header__wrapper");

if (header) {
  const collapsibles = header.querySelectorAll(".header-collapsible");
  const DELTA = 8; // ignore tiny scroll movements
  const LOCK_MS = 300; // ignore scroll events while the header resizes

  let collapsed = false;
  let lastY = window.scrollY;
  let lockUntil = 0;
  let ticking = false;

  const isVisible = (el) => el && el.getBoundingClientRect().height > 0;

  const setOffset = () => {
    const target = [
      header.querySelector(".logo-bar"),
      header.querySelector(".mobile-header__wrap"),
    ].find(isVisible);

    const offset = target
      ? Math.round(
          target.getBoundingClientRect().top -
            header.getBoundingClientRect().top,
        )
      : 0;

    header.style.setProperty("--header-offset", `${offset}px`);
  };

  const mobileMenuOpen = () =>
    !!document.querySelector(
      ".mobile-header__wrap.is-open, .mobile-header__search-bar.is-open",
    );

  const setCollapsed = (next) => {
    if (next === collapsed) return;
    collapsed = next;
    header.classList.toggle("is-collapsed", next);
    collapsibles.forEach((el) => el.toggleAttribute("inert", next));
    if (next) {
      Dropdown._active?.hide();
      header
        .querySelector(".header__account-menu")
        ?.classList.remove("is-open");
    }
    lockUntil = performance.now() + LOCK_MS;
  };

  const update = () => {
    ticking = false;

    const max = Math.max(
      0,
      document.documentElement.scrollHeight - window.innerHeight,
    );
    const y = Math.min(Math.max(window.scrollY, 0), max);

    if (performance.now() < lockUntil || mobileMenuOpen()) {
      lastY = y;
      return;
    }

    // Above the fold: always full nav
    if (y <= window.innerHeight) {
      setCollapsed(false);
      lastY = y;
      return;
    }

    const diff = y - lastY;
    if (Math.abs(diff) < DELTA) return;

    setCollapsed(diff > 0); // down = collapse, up = expand
    lastY = y;
  };

  window.addEventListener(
    "scroll",
    () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(update);
    },
    { passive: true },
  );

  window.addEventListener("resize", setOffset);
  if ("ResizeObserver" in window) {
    new ResizeObserver(setOffset).observe(header);
  }

  setOffset();
  update();
}
